import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Provider } from "../../../types/models/Provider";
import ProviderUserListItem from "../../../../timber/components/providerUser/ProviderUserList/ProviderUserListItem";
import CuttingListItem from "../../../../timber/components/cutting/CuttingList/CuttingListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: Provider;
};

const ProviderTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'providerUser');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Provider-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/ProviderUsers/list/view') &&
                    <Tab label={t`Provider Users`} value="providerUser"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/list/view') &&
                    <Tab label={t`Cuttings`} value="cutting"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/ProviderUsers/list/view') &&
                <TabPanel value={tabValue} index="providerUser" data-testid="ProviderUser-tab">
                    <ProviderUserListItem providerId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/list/view') &&
                <TabPanel value={tabValue} index="cutting" data-testid="Cutting-tab">
                    <CuttingListItem providerId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default ProviderTabs;
